import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    padding: 20,
  },
}));

export default function Plattegrond() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <label
        onClick={handleOpen}
        style={{
          maxWidth: "calc(100% )",
          borderRadius: 7,
          border: "black 1px solid",
        }}
      >
        Plattegrond
      </label>
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            position: "absolute",
          }}
          className={classes.paper}
        >
          <div
            style={{
              width: "800px",
              height: "800px",
              position: "relative",
            }}
          >
            <div
              stlye={{
                position: "absolute",
                top: 0,
                left: 0,
                "&:hover": {
                  background: "black",
                },
              }}
            >
              Kast 1
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
